import { siteData } from "../data/intelligence";

export function Methodology() { return <div className="panel"><h2>方法与数据说明</h2><p>本页仅消费 {siteData.meta.dataVersion} 静态数据；核验时间固定为 2026-08-01 17:09（Asia/Shanghai），不自动更新，也不连接钱包、账户或外部 API。</p><p>优先级综合呈现机会、风险、置信度、投入与紧迫度；评级与风险结论应结合每项公开证据、未知项和停止条件阅读。</p><p>证据等级以来源可核验性标注，外链在新窗口打开。</p></div>; }
